module.exports = __webpack_public_path__ + "img/sp.ca421ffc.svg";